import {
  FETCH_STUDENT_TEST_FAILURE, FETCH_STUDENT_TEST_SUCCESS, FETCH_STUDENT_TEST_RESULT,
  FETCH_TEACHER_CREATED_TEST_SUCCESS, FETCH_TESTS_FAILURE, FETCH_TESTS_REQUEST, FETCH_TESTS_SUCCESS,
  TEST_SUBMIT_FAILURE, TEST_SUBMIT_SUCCESS,
  FETCH_TEACHER_CREATED_TEST_IN_BIN_SUCCESS, FETCH_TEACHER_CREATED_TEST_IN_BIN_FAILURE,
  DELETE_TEST_DATA_SUCCESS_MESSAGE, DELETE_TEST_DATA_FALIURE_MESSAGE, RESTORE_DELETE_TEST_DATA_FALIURE_MESSAGE, RESTORE_DELETE_TEST_DATA_SUCCESS_MESSAGE, TEMP_DELETE_TEST_DATA_SUCCESS_MESSAGE,
  TEMP_DELETE_TEST_DATA_FAILURE_MESSAGE,
  CLEAR_TEST_RESULT,
  FETCH_TEACHER_CREATED_TEST,
  FETCH_TEACHER_CREATED_TEST_FAILURE,
  FETCH_TEST_BY_ID,
  FETCH_TEST_BY_ID_SUCCESS,
  FETCH_TEST_BY_ID_FAILURE,
  UPDATE_TEST_BY_ID,
  UPDATE_TEST_BY_ID_SUCCESS,
  UPDATE_TEST_BY_ID_FAILURE,
  FETCH_TEST_BY_ID_FOR_ALL_SUCCESS,
  FETCH_TEST_BY_ID_FOR_ALL_FAILURE,
  FETCH_TEST_BY_ID_FOR_ALL,
  SET_CURRENT_PAGE,
  UPDATE_TEST_SUCCESS,
  CLEAR_MESSAGE_FOR_DASHBOARD,
  UPDATE_TEST_FAILURE
} from "../actions/testActions";

const initialState = {
  tests: [],
  loading: false,
  error: null,
  testSubmitted: false,
  studenttestresult: [],
  teacherCreatedTest: [],
  finalresult: [],
  testbyid: [],
  studentresultloding: false,
  teacherCreatedTestloading: false,
  fetchingtestbyid: false,
  updatingtestbyid: false,
  fetchingtestbyidforall: false,
  testbyidforall: '',
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalTests: 0,
    limit: 10
  },
  filters: {
    category: 'All'
  },
  testUpdatedFailure: false,
  testUpdatedSuccess: false
};

const testReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TESTS_REQUEST:
      return {
        ...state,
        loading: true,
        filters: {
          ...state.filters,
          ...action.payload
        }
      };
    case FETCH_TESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        tests: action.payload.tests,
        pagination: {
          ...state.pagination,
          totalPages: action.payload.totalPages,
          totalTests: action.payload.totalTests,
          currentPage: action.payload.currentPage
        }
      };
    case FETCH_TESTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: action.payload
        }
      };
    case CLEAR_TEST_RESULT: // New case to handle clearing results
      return {
        ...state,
        finalresult: [],
        testSubmitted: false
      };



    case TEST_SUBMIT_SUCCESS:
      return {
        ...state,
        finalresult: action.payload,
        testSubmitted: true


      }

    case TEST_SUBMIT_FAILURE:
      return {
        ...state,
        testSubmitted: false

      }


    case FETCH_STUDENT_TEST_RESULT:
      return {
        ...state,
        studentresultloding: true,
      };
    case FETCH_STUDENT_TEST_SUCCESS:

      return {
        ...state,
        studenttestresult: action.payload,
        studentresultloding: false,

      }

    case FETCH_STUDENT_TEST_FAILURE:

      return {
        ...state,
        studentresultloding: false,

      };

    case FETCH_TEACHER_CREATED_TEST:
      return {
        ...state,
        teacherCreatedTestloading: true,
      }
    case FETCH_TEACHER_CREATED_TEST_SUCCESS:
      return {
        ...state,
        teacherCreatedTest: action.payload,
        teacherCreatedTestloading: false,
      }
    case FETCH_TEACHER_CREATED_TEST_FAILURE:
      return {
        ...state,
        teacherCreatedTestloading: false,
      }

    case FETCH_TEACHER_CREATED_TEST_IN_BIN_FAILURE:
      return {
        ...state,
      }
    case FETCH_TEACHER_CREATED_TEST_IN_BIN_SUCCESS:
      return {
        ...state,
        teacherCreatedTestInBin: action.payload,
      }
    case DELETE_TEST_DATA_SUCCESS_MESSAGE:
      return {
        ...state,
        deleteTestDataSuccessMsgPermanently: action.payload,
      }
    case TEMP_DELETE_TEST_DATA_SUCCESS_MESSAGE:
      return {
        ...state,
        deleteTestDataSuccessMsg: action.payload,
      }
    case DELETE_TEST_DATA_FALIURE_MESSAGE:
      return {
        ...state,
        deleteFailure: action.payload,
      }
    case TEMP_DELETE_TEST_DATA_FAILURE_MESSAGE:
      return {
        ...state,
        deleteFailurePermanently: action.payload,
      }
    case RESTORE_DELETE_TEST_DATA_SUCCESS_MESSAGE:
      return {
        ...state,
        restoreSuccessMessage: action.payload,
      }
    case RESTORE_DELETE_TEST_DATA_FALIURE_MESSAGE:
      return {
        ...state,
        asdfdsfdsf: action.payload,
      }

    case FETCH_TEST_BY_ID:
      return {
        ...state,
        fetchingtestbyid: true,
      }
    case FETCH_TEST_BY_ID_SUCCESS:
      return {
        ...state,
        testbyid: action.payload,
        fetchingtestbyid: false,
      }
    case FETCH_TEST_BY_ID_FAILURE:
      return {
        ...state,
        fetchingtestbyid: false,
      }

    case UPDATE_TEST_BY_ID:
      return {
        ...state,
        updatingtestbyid: true,
      }
    case UPDATE_TEST_BY_ID_SUCCESS:
      return {
        ...state,
        testbyid: action.payload,
        updatingtestbyid: false,
      }
    case UPDATE_TEST_BY_ID_FAILURE:
      return {
        ...state,
        updatingtestbyid: false,
      }

    case FETCH_TEST_BY_ID_FOR_ALL:
      return {
        ...state,
        fetchingtestbyidforall: true,
      }

    case FETCH_TEST_BY_ID_FOR_ALL_SUCCESS:
      return {
        ...state,
        testbyidforall: action.payload,
        fetchingtestbyidforall: false,
      }
    case FETCH_TEST_BY_ID_FOR_ALL_FAILURE:
      return {
        ...state,
        fetchingtestbyidforall: false,
      }
    case UPDATE_TEST_SUCCESS:
      return {
        ...state,
        testUpdatedSuccess: true,
      };
    case UPDATE_TEST_FAILURE:
      return {
        ...state,
        testUpdatedFailure: true
      };

    case CLEAR_MESSAGE_FOR_DASHBOARD:
      return {
        ...state,
        testUpdatedSuccess: false,
        testUpdatedFailure: false
      };

    default:
      return state;
  }
};

export default testReducer;
